import request from '@/utils/request'

 
export function fetchList(data) {
  return request({
    url: '/InBodyRecord/ListRecordForStudent',
    method: 'post',
    data ,
  })
}
 


export function coachFetchList(data) {
  return request({
    url: '/InBodyRecord/ListRecordForCoach',
    method: 'post',
    data ,
  })
}
 

 